export const hasOnlyDigits = (v) => /^\d+$/.test(v);
export const hasOnlyDigitsAndSymbols = (v) => /^[\d-+/*]+$/.test(v)
